import * as React from 'react';

import * as styles from './styles.css';

export const DefaultPreview: React.FC = () => {
  return <div className={styles['image']} />;
};
